import { BannerLayer } from "../../../util/api.types";
import { BannerPickedLayers } from "./types";

export function getBannerLayers(banner: BannerPickedLayers): BannerLayer[] {
    return banner && !!banner.layers && Array.isArray(banner.layers) ? banner.layers : [];
}
